import { render, staticRenderFns } from "./BuilderTranscription.vue?vue&type=template&id=22aae97a&scoped=true&"
import script from "./BuilderTranscription.vue?vue&type=script&lang=js&"
export * from "./BuilderTranscription.vue?vue&type=script&lang=js&"
import style0 from "./BuilderTranscription.vue?vue&type=style&index=0&id=22aae97a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aae97a",
  null
  
)

export default component.exports